var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VRadio',{staticClass:"wp-base-radio",attrs:{"id":_vm.id,"disabled":_vm.disabled,"label":_vm.label,"name":_vm.name,"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }